import React from 'react';

import './Landing.css';

import { MainContent } from './styles/CoreStyle';

// all other section page imports
// landing 100vh section
import { LandingSection } from './components/sections/landing/LandingSection';
// about section import
import { AboutSection } from './components/sections/about/AboutSection';
// project section import
import { ProjectSection } from './components/sections/projects/ProjectSection';


function Landing({ author }) {
  return (
    <div id='LandingApp' className="landing-app">
      <MainContent id='mainContent'>
        <LandingSection profilePicture={author.image} roles={author.roles} />
        <AboutSection bio={author._rawBio} name={author.name} />
        <ProjectSection />
        {/* <ContactSection /> */}
      </MainContent>
    </div>
  );
}

export default Landing;
